import React, { Component } from 'react';
import { animateScroll as scroll } from 'react-scroll';
import './ScrollToTop.scss';
import '@fortawesome/fontawesome-free/css/all.min.css';

export class ScrollToTop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      IS_VISIBLE: false,
    };
  }

  componentDidMount() {
    document.addEventListener('scroll', this.scrollHandler.bind(this));
  }
  scrollHandler = () => {
    this.toggleVisibility();
  }

  toggleVisibility() {
    this.setState({
      IS_VISIBLE: window.pageYOffset > 300,
    });
  }

  render() {
    const { IS_VISIBLE } = this.state;
    return IS_VISIBLE &&
    <button
      type="button"
      title="Back to top"
      className="scroll"
      onClick={() => { scroll.scrollToTop(); }}
    >
      <span id="icon" className="fas fa-arrow-up" />
    </button>;
  }
}
